import { useDashboardToolModals } from '../../context/DashboardModalsContext';
import ProfileModal from './ProfileModal';
import UrlEditorModal from './UrlEditorModal';
import RemoveDuplicatesModal from './RemoveDuplicatesModal';
import PrefixSuffixModal from './PrefixSuffixModal';
import StreamFormatModal from './StreamFormatModal';
import GuideModal from './GuideModal';
import CreateChannelModal from './CreateChannelModal';
import CreateCategoryModal from './CreateCategoryModal';
import NameOptimizerModal from './NameOptimizerModal';
import SearchReplaceNameModal from './SearchReplaceNameModal';
import CaseConvertModal from './CaseConvertModal';
import MoveCopyChannelsModal from './MoveCopyChannelsModal';
import ShowOnlyDuplicatesModal from './ShowOnlyDuplicatesModal';
import { EpgCountriesModal, EpgExternalSourceModal, EpgSettingsModal } from './EpgNavModals';
import SortStreamsCategoriesModal from './SortStreamsCategoriesModal';
import EpgAssignmentAssistantModal from './EpgAssignmentAssistantModal';
import EpgCreatorModal from './EpgCreatorModal';

export default function DashboardModalsHost() {
  const { active, closeToolModal } = useDashboardToolModals();

  const moveCopyOpen = active === 'move-channels-playlist' || active === 'copy-channels-playlist';
  const moveCopyInitialMode = active === 'copy-channels-playlist' ? 'copy' : 'move';

  return (
    <>
      <ProfileModal show={active === 'profile'} onClose={closeToolModal} />
      <UrlEditorModal show={active === 'url-editor'} onClose={closeToolModal} />
      <RemoveDuplicatesModal show={active === 'remove-duplicates'} onClose={closeToolModal} />
      <PrefixSuffixModal show={active === 'prefix-suffix'} onClose={closeToolModal} />
      <StreamFormatModal show={active === 'stream-format'} onClose={closeToolModal} />
      <GuideModal show={active === 'guide'} onClose={closeToolModal} />
      <CreateChannelModal show={active === 'create-channel'} onClose={closeToolModal} />
      <CreateCategoryModal show={active === 'create-category'} onClose={closeToolModal} />
      <NameOptimizerModal show={active === 'name-optimizer'} onClose={closeToolModal} />
      <SearchReplaceNameModal show={active === 'search-replace-name'} onClose={closeToolModal} />
      <CaseConvertModal show={active === 'case-convert'} onClose={closeToolModal} />
      <ShowOnlyDuplicatesModal show={active === 'show-only-duplicates'} onClose={closeToolModal} />
      <MoveCopyChannelsModal show={moveCopyOpen} onClose={closeToolModal} initialMode={moveCopyInitialMode} />
      <EpgCountriesModal show={active === 'epg-countries'} onClose={closeToolModal} />
      <EpgExternalSourceModal show={active === 'epg-external'} onClose={closeToolModal} />
      <EpgSettingsModal show={active === 'epg-settings'} onClose={closeToolModal} />
      <SortStreamsCategoriesModal show={active === 'sort-streams-categories'} onClose={closeToolModal} />
      <EpgAssignmentAssistantModal
        show={active === 'epg-assignment-assistant'}
        onClose={closeToolModal}
      />
      <EpgCreatorModal show={active === 'epg-creator'} onClose={closeToolModal} />
    </>
  );
}
